import { h } from './components/element.mjs';
import DataProxy from './core/data_proxy.mjs';
import Page from './components/page.mjs';
import Sidebar from './components/sidebar.mjs';
import { cssPrefix } from './config.mjs';
import { localEn, Localization } from './lookup.mjs';
import FieldEditor from './components/PropertiesModal.mjs'; 
import FormulaEditor from './components/multi-edit-modal.mjs'; 
import Toolbar from './components/toolbar.mjs';
import { jsPDF } from 'jspdf';
import { Formulas } from './core/formulas.mjs';

/**
 * Class          : FormEngine
 * Author         : Pratheeshkumar N P
 * Created On     : 08-Apr-2025 
 * Other Fn calls :
 * Comments       :
 * ================================================================================================
 *   Last Modified By  ||    Date        ||    Purpose/Reason
 * ================================================================================================
 */

class FormEngine {
    constructor(pdf, options) {
        this.targetEl = options.wrappers.container;
        this.scrollContainer = options.wrappers.maincontainer;
        this.pdf = pdf;
        this.pageIndex = 0;
        this.options = { ...options, width: options.wrappers.container.clientWidth };
        this.datas = [];
        this.pages = []; 
        this.view = {
            width: this.targetEl.clientWidth
        };
        this.loc = new Localization(options.localization);
        this.formulas = new Formulas();
        this.fieldEditor = this.options.editMode ? new FieldEditor(options.wrappers.editContainer, this.changeProperties, this.changeAlign, this.removeField, this.loc) : null;
        this.formulaEditor = this.options.editMode ? new FormulaEditor(options.wrappers.formulaContainer, this.updateFormula, this.loc, this.formulas) : null;
        this.lookup = null;
        //this.multiFieldEditor = this.options.editMode ? new MultiFieldEditor() : null;
        this.targetEl.classList.add("h-100");
        this.targetEl.innerHTML = "";
        this.sidebar = this.options.showSideBar ? new Sidebar(() => {
            if (this.options.mode === 'read') return;
            const d = this.addPage();
            this.page.resetData(d);
        }, (index) => {
            const d = this.datas[index];
            this.page.resetData(d);
        }, () => {
            this.deletePage();
        }, (index, value) => {
            this.datas[index].name = value;
            this.page.trigger('change');
        }) : null;
        this.data = this.addPage();
        this.selectedTool = '';
        this.toolbar = this.options.editMode ? new Toolbar((it) => {
            this.selectedTool = it ?? '';
        }) : null;
        this.setToolbar();
        const rootEl = h('div', `${cssPrefix}-page-container d-flex flex-column gap-3`)
            .on('contextmenu', evt => evt.preventDefault()); 
        this.rootEl = rootEl;
        this.targetEl.appendChild(this.rootEl.el);
        this.page = new Page(rootEl, this.data);
        this.prevDatas = this.datas;
        this.currentPageIndex = 0;
        
        this.activeTask = null;
        this.selectedTask = null;
        
    } 
    addPage(name, pageIndex, page, active = true) {
        const n = name || `page${this.pageIndex}`; 
        const d = new DataProxy(n, this.options, page, pageIndex, this.fieldEditor, this.formulaEditor);
        d.change = (...args) => {
            this.page.trigger('change', ...args);
        };
        this.datas.push(d);
        this.pageIndex += 1;
        return d; 
    }
    deletePage() {
        
    }
    async loadData(data, formulas) {
        const datas = await parsePdfFormFields(this.pdf, this.view.width); 
        const ds = Array.isArray(data) ? data : [data];
        this.datas = []; 
        this.pages = []; 
        this.rootEl.el.innerHTML = "";
        if (datas.length > 0) {
            for (let i = 0; i < datas.length; i += 1) {
                const it = ds[i] ?? null; 
                const pageData = it || datas[i];
                const pageName = it?.name || `page${this.pageIndex}`;
                const pageIndex = it?.pageIndex || this.pageIndex;

                const nd = this.addPage(pageName, pageIndex, datas[i].page, pageIndex === 1); 
                nd.setData(pageData);

                const page = new Page(this.rootEl, nd, null, (prop) => this.getprops(prop) );
                await page.render();
                this.pages.push(page);
            }
            this.page = this.pages[0];
        }
        
        this.setScroll();
        return this; 
    } 
    async setValues(newValues) {
        await this.datas.map(it => it.setValues(newValues));
        for (var p of this.pages) {
            p.refreshValues();
        } 
    }
     
    redo() {
        for (var p of this.pages) {
            p.redo();
        }
    }
    undo() {
        for (var p of this.pages) {
            p.undo();
        }
    }
    getData() {
        return {
            data: this.datas.map(it => it.getData()),
            formulas: this.formulas.getData()
        }
    }
    getValues() {
        return this.datas.map(it => it.getValues()).flat();
    }
    setToolbar() { 
        const tc = this.options?.wrappers?.toolbarContainer;
        if (this.options.editMode && tc && this.toolbar?.el?.el) {
            tc.innerHTML = '';
            tc.appendChild(this.toolbar.el.el);
        }
    }
    escapeTool() {
        this.selectedTool = '';
        this.toolbar.clearSelection();
    }
    changeProperties(annot) {
        console.log("changedata");
    }
    updateFormula(d) {
        this.formulas.add(d);
        console.log(d);
    }
    changeAlign() { }
    removeField(code) {
        console.log("deletefield");
    }
    getprops(which) { 
        return (which ? this[which] : null);
    }
    async populateLookup(d) {
        try {
            if (this.fieldEditor && this.options.editMode) {
                this.fieldEditor.populateLookup(d);
            } else {
                if (d) {
                    this.lookup = d;
                    for (var p of this.pages) {
                        await p.render();
                    } 
                }
            }
        } catch (error) {
            console.error("Error in populateLookup:", error);
            // Optional: show user feedback or fallback behavior here
        }
    }
    getDocumentasPdf(showField = false) {
        //pdf_lib.
    }
    setLanguage(data) { 
        this.loc = new Localization(data)
    }
    scrollToPage(index) {
        const container = this.targetEl; 
        const pages = container.querySelectorAll(".fe-page");

        if (index == null) {
            index = pages?.length - 1;
        }

        if (index < 0 || index >= pages.length) return;

        pages[index].scrollIntoView({ behavior: "smooth", block: "start" });
        
        this.currentPageIndex = index;
        if (this.activeTask == 'formula') openFormula();
    }
    scrollToNextPage() {
        const { currentPageIndex } = this;
        this.scrollToPage(currentPageIndex + 1);
    }
    scrollToPrevPage() {
        const { currentPageIndex } = this;
        this.scrollToPage(currentPageIndex - 1);
    }
    scrollToFirstPage() { 
        this.scrollToPage(0);
    }
    scrollToLastPage() {
        this.scrollToPage(null);
    }
   
    setScroll() {
        const scrollContainer = this.scrollContainer;
        const container = this.targetEl; 
        const pages = container.querySelectorAll(".fe-page");
        scrollContainer.addEventListener("scroll", () => {
            let closestIndex = 0;
            let closestOffset = Infinity;

            pages.forEach((page, index) => {
                const offset = Math.abs(page.getBoundingClientRect().top - scrollContainer.getBoundingClientRect().top);
                if (offset < closestOffset) {
                    closestOffset = offset;
                    closestIndex = index;
                }
            });

            if (closestIndex !== this.currentPageIndex) {
                this.currentPageIndex = closestIndex; 
            }
        });
    }
    openFormula() {
        return new Promise(async (resolve, reject) => {
            try {
                const { currentPageIndex, pages } = this;
                this.fieldEditor.hide();
                this.formulaEditor.hide();
                this.formulaEditor.setData(this);
                this.formulaEditor.show();
                this.activeTask = 'formula';

                resolve();

            } catch (err) {
                console.error("openFormula failed", err);
                reject(err); 
            }
        })
    }
    closeFormula() {  
        this.formulaEditor.hide();
        for (var p of this.pages) {
            p.selectedTask=null;
        } 
        this.activeTask = null;
        const { currentPageIndex } = this;
        this.pages[currentPageIndex].openIfProperties();
    }
    async downloadPdf() { 
        const firstCanvas = this.pages[0]?.canvas?.el;
        if (!firstCanvas) return;

        const canvasW = firstCanvas.width;
        const canvasH = firstCanvas.height;

        const pdf = new jsPDF({
            orientation: canvasW > canvasH ? 'landscape' : 'portrait',
            unit: 'px',
            format: [canvasW, canvasH]
        });
        let i = 0;
        for (var p of this.pages) {
            await p.renderPreview(); 

            const canvas = p.canvas?.el;

            if (!canvas) continue;

            const imgData = canvas.toDataURL("image/png");
             

            if (i > 0) pdf.addPage([canvas.width, canvas.height]);

            pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height);

            i++;
        } 
        pdf.save("download.pdf");
    }
 
}

async function parsePdfFormFields(pdf,w) {
    const pages = [];
    var i = 0;
    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) { 
        const page = await pdf.getPage(pageNum);
        const annottation = await page.getAnnotations();  
        const scaleFactor = w / page.getViewport({ scale: 1 }).width;
        let viewport = page.getViewport({ scale: scaleFactor });
        const fields = [];
        annottation.forEach(annot => {
            var type = "none";
            var name = ""; 
            var value = "";
            var checked = false;
            var placeholder = "";
            const code = annot.id;
            name = annot.fieldName;
            switch (annot.fieldType) {
                case "Tx":
                    if (annot.multiLine) {
                        type = "textarea";
                    } else {
                        type = "textbox";
                    }

                    value = annot.fieldValue || "";
                    break;

                case "Btn":
                    if (annot.checkBox) {
                        type = "checkbox";
                        checked = annot.checkBoxValue === "Yes";
                    } else if (annot.radioButton) {
                        type = "radio";
                        checked = annot.radioValue === "Yes";
                    } else if (annot.pushButton) {
                        type = "submit";
                        value = annot.fieldName || "Submit";
                    } else {
                        type = "button";
                        value = annot.fieldName || "button";
                    }
                    break;

                case "Ch":
                    type = "combobox";
                    break;

                case "Sig":
                    type = "signature";
                    placeholder = "Signature Here";

                    break;

                default:
                    //console.warn("Unknown annotation type:", annot.type);
                    return null;
            }
            const readOnly = false;
            const [x1, y1, x2, y2] = annot.rect.map(i => i * scaleFactor);
            const left = x1;
            const top = viewport.height - y2;
            const width = x2 - x1;
            const height = y2 - y1;
            const fontSize = annot.defaultAppearanceData?.fontSize > 0 ? annot.defaultAppearanceData.fontSize * scaleFactor : 14;
            const borderStyle = "none";
            const textAlign = annot.textAlignment === 1 ? "center" : annot.textAlignment === 2 ? "right" : "left";
            const style = { textAlign, fontSize, borderStyle };
            const field = { code, name, type, width, height, left, top, readOnly, ...style, scaleFactor }; 
            fields.push(field);
        });
        pages.push({ page, fields });
    }
    return pages;
}
export { FormEngine };